(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/lazy/assets/javascripts/lazy.js') >= 0) return;  svs.modules.push('/components/lb-utils/lazy/assets/javascripts/lazy.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

const _React = React,
  useEffect = _React.useEffect,
  useReducer = _React.useReducer;
const _module = svs.core.module;
const getLogger = svs.core.log.getLogger;
const logger = getLogger('lb-utils:lazy');
const reducer = (state, action) => {
  switch (action.type) {
    case 'retry':
      return _objectSpread(_objectSpread({}, state), {}, {
        error: null
      });
    case 'loaded':
      return _objectSpread(_objectSpread({}, state), {}, {
        error: null,
        Component: action.payload
      });
    case 'error':
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.error
      });
    default:
      throw new Error("Unexpected action: ".concat(action.type));
  }
};
const initialState = {
  Component: null,
  error: null
};
function lazy(myComp, cb, options) {
  const pendingLoading = {};
  const tryToLoad = (component, callback) => {
    if (pendingLoading[component]) {
      if (callback && !pendingLoading[component].includes(callback)) {
        pendingLoading[component].push(callback);
      }
      return;
    }
    const onLoaded = function () {
      for (const cb of pendingLoading[component]) {
        cb(...arguments);
      }
      delete pendingLoading[component];
    };
    pendingLoading[component] = [];
    if (callback) {
      pendingLoading[component].push(callback);
    }
    if (component.startsWith('/cl/')) {
      _module.load(component, undefined, onLoaded);
    } else {
      _module.loadModuleComponent(component, onLoaded);
    }
  };
  const LazyComponent = props => {

    let cachedComp;
    try {
      cachedComp = cb();
    } catch (_unused) {
      tryToLoad(myComp);
    }
    const initial = _objectSpread(_objectSpread({}, initialState), {}, {
      Component: cachedComp
    });
    const _useReducer = useReducer(reducer, initial),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];
    useEffect(() => {
      let wasCancelled = false;
      if (!state.error && !state.Component) {
        const loadCallback = error => {
          if (!wasCancelled) {
            if (error) {
              logger.warn("Failed to fetch component: ".concat(myComp, " status: ").concat(error.status, " msg: ").concat(error.statusMessage));
              dispatch({
                type: 'error',
                error: {
                  code: error.status,
                  message: error.statusMessage
                }
              });
            } else {
              dispatch({
                type: 'loaded',
                payload: cb()
              });
            }
          }
        };
        tryToLoad(myComp, loadCallback);
      }
      return () => {
        wasCancelled = true;
      };
    }, [state.Component, state.error]);
    const onRetry = () => {
      dispatch({
        type: 'retry'
      });
    };
    if (!state.Component) {
      if (options !== null && options !== void 0 && options.error && state.error) {
        const Error = options.error;
        return React.createElement(Error, {
          componentProps: props,
          error: state.error,
          onRetry: onRetry
        });
      }
      if (options !== null && options !== void 0 && options.fallback) {
        const Fallback = options.fallback;
        return React.createElement(Fallback, {
          componentProps: props
        });
      }
      return null;
    }

    return React.createElement(state.Component, props);
  };
  return LazyComponent;
}
setGlobal('svs.components.lbUtils.lazy.lazy', lazy);

 })(window);